module.exports = __webpack_public_path__ + "static/media/case-02.6a72fc27.png";